import React, { useState } from 'react';
import { withApollo } from 'react-apollo';
import { useMutation, useQuery } from '@apollo/react-hooks';
import {
  Button, Row, Spinner, Table, Jumbotron, Col,
} from 'reactstrap';
import { GET_TEST_BOXES } from '../../query/query';
import { ADD_TEST_BOXES, REMOVE_TEST_BOX, SET_TARGET_VERSION_TO_TEST_GROUP } from '../../mutation/mutation';
import Stats from './Stats';

const addBoxMutation = (testGroupName) => useMutation(ADD_TEST_BOXES, {
  update(cache, { data: { savAddTestBoxes: boxes } }) {
    if (!boxes) { return; }
    const { savGetTestBoxes } = cache.readQuery({
      query: GET_TEST_BOXES,
      variables: { testGroupName },
    });
    savGetTestBoxes.push(...boxes);
    cache.writeQuery({
      query: GET_TEST_BOXES,
      variables: { testGroupName },
      data: { savGetTestBoxes },
    });
  },
});

const removeBoxMutation = (testGroupName) => useMutation(REMOVE_TEST_BOX, {
  update(cache, { data: { savRemoveTestBox: box } }) {
    if (!box) { return; }
    const { savGetTestBoxes } = cache.readQuery({
      query: GET_TEST_BOXES,
      variables: { testGroupName },
    });
    const boxes = savGetTestBoxes.filter((b) => b._id !== box._id);
    cache.writeQuery({
      query: GET_TEST_BOXES,
      variables: { testGroupName },
      data: { savGetTestBoxes: boxes },
    });
  },
});

const createSetTargetVersionMutation = (testGroupName) => (
  useMutation(SET_TARGET_VERSION_TO_TEST_GROUP, {
    update(cache, { data: { savSetTargetVersionToTestGroup: targetVersion } }) {
      if (!targetVersion) { return; }
      const { savGetTestBoxes } = cache.readQuery({
        query: GET_TEST_BOXES,
        variables: { testGroupName },
      });
      const boxes = savGetTestBoxes.map((box) => {
        // eslint-disable-next-line no-param-reassign
        box.versions.targetVersion = targetVersion;
        return box;
      });
      cache.writeQuery({
        query: GET_TEST_BOXES,
        variables: { testGroupName },
        data: { savGetTestBoxes: boxes },
      });
    },
  })
);

const confirmSetTargetVersion = ({
  setTargetVersion, setTargetVersionMutation, targetVersion, testGroupName,
}) => {
  if (confirm(`${testGroupName}: set target version to ${targetVersion}`)) { // eslint-disable-line
    setTargetVersionMutation({ variables: { targetVersion, testGroupName } }).then(() => setTargetVersion(''));
  }
};

const capitalizeFirstLetter = (string) => (
  `${string.charAt(0).toUpperCase() + string.slice(1)}`
);

const BoxList = ({ boxes = [], removeTestBox = () => null, testGroupName }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>MAC Address</th>
        <th>Current Version</th>
        <th>Target Version</th>
        <th>Last Received Version</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {boxes.map((
        {
          _id,
          macAddress,
          versions: { currentVersion, targetVersion, lastReceivedVersion } = {},
        },
        index,
      ) => (
        <tr key={_id}>
          <th scope="row">{index}</th>
          <td>{macAddress}</td>
          <td>{currentVersion}</td>
          <td>{targetVersion}</td>
          <td>{lastReceivedVersion}</td>
          <td>
            <Button
              onClick={() => removeTestBox({ variables: { macAddress } })}
              color="danger"
            >
              {`Remove from ${testGroupName}`}
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default withApollo(({ testGroupName }) => {
  const {
    data,
    loading,
  } = useQuery(
    GET_TEST_BOXES,
    {
      variables: { testGroupName },
    },
  ) || {};
  const testGroup = capitalizeFirstLetter(testGroupName);
  const [macAddress, setMacAddress] = useState('');
  const [targetVersion, setTargetVersion] = useState('');
  const [addTestBox] = addBoxMutation(testGroupName);
  const [removeTestBox] = removeBoxMutation(testGroupName);
  const [setTargetVersionMutation] = createSetTargetVersionMutation(testGroupName);
  return (
    <Jumbotron>
      <Col>
        <Row>
          <h1>{`${testGroup} release`}</h1>
        </Row>
        <Row style={{ marginTop: 20, marginBottom: 20 }}>
          <h2>{`Set ${testGroup} target version to`}</h2>
          <input
            type="text"
            onChange={({ target: { value } }) => setTargetVersion(value)}
            value={targetVersion}
          />
          <Button
            color="success"
            onClick={() => confirmSetTargetVersion({
              setTargetVersion, setTargetVersionMutation, targetVersion, testGroupName,
            })}
            style={{ marginLeft: 30 }}
          >
            Set target version
          </Button>
        </Row>
        {
          (loading || !data)
            ? <Spinner color="primary" />
            : (
              <Row>
                <Stats boxes={data.savGetTestBoxes} />
                <BoxList
                  boxes={data.savGetTestBoxes}
                  testGroupName={testGroupName}
                  removeTestBox={removeTestBox}
                />
                <div>{`Total: ${(data.savGetTestBoxes || []).length}`}</div>
              </Row>
            )

        }
        <Row style={{ marginTop: 20, marginBottom: 20 }}>
          <h2>{`Add box to ${testGroup}`}</h2>
          <input
            type="text"
            onChange={({ target: { value } }) => setMacAddress(value)}
            value={macAddress}
          />
          <Button
            color="success"
            onClick={() => addTestBox({ variables: { macAddresses: macAddress, testGroupName } }).then(() => setMacAddress(''))}
            style={{ marginLeft: 30 }}
          >
            Add box
          </Button>
        </Row>
      </Col>
    </Jumbotron>
  );
});



// WEBPACK FOOTER //
// ./src/components/ota/TestReleasePanel.js